<template>
  <div class="details">
    <div class="details__title" :class="titleClasses">
      {{ displayName }}
    </div>
    <div class="details__concentration concentration">
      <div class="concentration__color-box" :style="colorBoxStyles"></div>
      <div class="concentration__value u-typography-helvetica u-text u-text--l">
        {{ concentration }}
      </div>
    </div>
    <div class="details__description u-typography-helvetica u-text u-text--m">
      {{ description }}
    </div>
  </div>
</template>

<script>
import { getIngredientName, getIngredientTotalConcentration } from '@/models/core/Ingredient';

import { INGREDIENT_DESCRIPTION_KEY, INGREDIENT_NAME_KEY } from '@/constants/ingredients';

export default {
  name: 'IngredientDetails',
  props: {
    ingredient: {
      type: Object,
      required: true
    }
  },
  computed: {
    concentration() {
      const totalConcentration = getIngredientTotalConcentration(this.ingredient).toFixed(1);

      return `${totalConcentration}%`;
    },
    name() {
      return getIngredientName(this.ingredient);
    },
    description() {
      return this.$t(INGREDIENT_DESCRIPTION_KEY[this.name]);
    },
    displayName() {
      return this.$t(INGREDIENT_NAME_KEY[this.name]);
    },
    colorBoxStyles() {
      return {
        backgroundColor: `var(--u-color-${this.name})`
      };
    },
    titleClasses() {
      if (this.$windowWidth.value < 1920) {
        return ['u-typography-helvetica', 'u-text-display', 'u-text-display--s'];
      }

      return ['u-typography-helvetica', 'u-text-display', 'u-text-display--m'];
    }
  }
};
</script>

<style lang="scss" scoped>
.details {
  &__title {
    color: var(--u-color-grey-900);
    margin-bottom: 16px;
  }

  &__concentration {
    color: var(--u-color-grey-600);
    margin-bottom: 16px;
  }

  &__description {
    color: var(--u-color-grey-600);
  }
}

.concentration {
  display: flex;
  align-items: center;

  &__color-box {
    width: 24px;
    height: 24px;
    margin-inline-end: 16px;
    border-radius: 1px;
  }
}
</style>
